import { useCssTokens } from '../../hooks/useCssTokens';

const breakpointTokens = [
  { token: 'breakpoint-sm', label: 'sm / phone' },
  { token: 'breakpoint-md', label: 'md / tablet' },
  { token: 'breakpoint-lg', label: 'lg / laptop' },
  { token: 'breakpoint-xl', label: 'xl / desktop' },
  { token: 'breakpoint-2xl', label: '2xl / wide' },
];

const layoutTokens = [
  ...breakpointTokens.map((item) => item.token),
  'container-max',
  'container-padding',
  'grid-columns',
  'grid-gutter',
];

export function LayoutShowcase() {
  const values = useCssTokens(layoutTokens);

  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Breakpoints</h4>
        <div className="grid grid-cols-5 gap-3">
          {breakpointTokens.map((item) => (
            <div key={item.token} className="rounded-2xl border border-border/40 p-3 text-center">
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
                {item.label}
              </p>
              <p className="mt-1 text-sm font-medium text-foreground">{values[item.token]}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-2xl border border-border/40 p-4">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Container max</p>
          <p className="mt-2 text-sm text-foreground">{values['container-max']}</p>
        </div>
        <div className="rounded-2xl border border-border/40 p-4">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
            Container padding
          </p>
          <p className="mt-2 text-sm text-foreground">{values['container-padding']}</p>
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Grid</h4>
        <div className="rounded-2xl border border-border/40 p-4">
          <div className="mb-4 flex flex-wrap gap-4 text-xs text-muted-foreground">
            <span>columns: {values['grid-columns']}</span>
            <span>gutter: {values['grid-gutter']}</span>
          </div>
          <div
            className="grid h-24"
            style={{
              gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
              gap: values['grid-gutter'] || '24px',
            }}
          >
            {Array.from({ length: 12 }).map((_, index) => (
              <div key={index} className="rounded-lg bg-muted" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
